import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../../common/components/Icon/Icon";

interface CustomerNoteDisplayProps {
  note: string;
}

const CustomerNoteDisplay: React.FC<CustomerNoteDisplayProps> = ({ note }) => {
  const { t } = useTranslation();

  if (!note) return null;

  return (
    <div className="customer-note-display">
      <h3 className="customer-note-display__title">
        <Icon iconName="document-text" className="icon--stroke-thick" />
        {t("orderPage.customerNoteTitle", "Order Note")}
      </h3>
      <p className="customer-note-display__content">{note}</p>
    </div>
  );
};

export default CustomerNoteDisplay;
